// extracted by mini-css-extract-plugin
export default {"wrapper":"jC2uJ99qacOPvHV8zCmFag==","illustration":"dyaRShrcV+Wh98b4PA4KYw==","title":"XYR+7TRTMha7OfORqp5fIw== heading-page","description":"QKYhQCCBCHmaeiLIez-fww== body-standard"};